import { getWindow } from './window.js';

export const getFuseTag = () => {
  const lclWindow = getWindow();
  if (lclWindow) {
    return lclWindow.fusetag || (lclWindow.fusetag = { que: [] } as unknown as Window['fusetag']);
  }
  return { que: [] } as unknown as Window['fusetag'];
};
